<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <p>Checking confirmation key</p>
    </div>
  </div>
</template>

<script>
import { notifyMixin } from '@/mixins/notifyMixin'
export default {
  data () {
    return {
      value1: '',
      value2: '',
      value3: ''
    }
  },
  mixins: [notifyMixin],
  created () {
    this.$vs.loading()
    const payload = {
      checkbox_remember_me: true,
      userDetails: {
        email: "EmailConfirm",
        password: this.$route.query.key
      }
    }

    this.$store.dispatch('auth/loginJWT', payload)
      .then(() => {
        this.$store.dispatch('auth/fetchProfile').then(() => {
          this.$vs.loading.close()
          this.$router.push("/profile")
        })
      })
      .catch(error => {
        this.$vs.loading.close()
        this.notifyError(error)
      })
  }
}
</script>
